import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';
import { getDeviceGroupId } from 'utils/common/registerDevGroupID';

function getOrganizationGroupChannelByGroup() {
  const group_id = getDeviceGroupId()
  return httpService.get(ApiUrl.ORGANIZATIONGROUPCHANNEL + '?organization_group_id=' + group_id);
}

const obj = { getOrganizationGroupChannelByGroup };

export default obj;
